



































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {WidgetFilterOptions} from '@/components/widgets/WidgetFather'
import {getAutocompleteFn} from '@/data/sources/autocomplete'

@Component({})
export default class InputLocation extends Vue {
  @Prop() public opts!: WidgetFilterOptions
  @Prop() public value!: string
  @Prop() public disabled!: boolean
  public inputId = 'input-' + String(Math.floor((Math.random() * 100000)))
  public autocomplete = () => import("@/components/inputs/AutocompleteLocation.vue")
  public showAutocomplete = false
  public acValue: string = ""
  public focused: boolean = false
  public title: string = ''
  private autocompleteFunction: any = null

  @Watch('value')
  onValueChange(val: string) {
    this.acValue = String(val)
  }

  @Watch('acValue')
  onAcValueChange(val: string) {
    this.title = ''
    try {
      parseInt(val)
    } catch {
      return
    }
    this.$emit('input', val)
  }

  @Watch('focused', {immediate: true})
  onFocusedChange(val: string) {
    !this.focused && setTimeout(() => this.autocompleteFunction && this.autocompleteFunction(this.value), 300)
  }

  get extendedValue() {
    return this.title ? `${this.title} (${this.value})` : this.value
  }

  public hideAutocomplete() {
    setTimeout(() => this.showAutocomplete = false, 300)
    this.focused = false
  }

  public created() {
    const af = getAutocompleteFn(this.opts.autocompleteFn || '')
    this.autocompleteFunction = async (loc: string) => {
      const r = await af(loc, true)
      const lTypes: { [key: string]: string } =
        {o: '', g: 'Region:', s: 'Site:', b: 'Building:', f: 'Floor', r: 'Room:'}
      if (r && r.length === 1) {
        this.title = `${lTypes[r[0]['type']]} ${r[0]['name']}`
      }
    }
    this.value && this.autocompleteFunction && this.autocompleteFunction(this.value)
  }

  public reset() {
    this.$emit('input', "10")
    this.onFocusedChange("xx")
  }

  public textInputFocused(event: any) {
    this.showAutocomplete = true
    event.target.select()
  }
}
